(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-branding-made-simple"] && !Shopify.designMode) return;
  try {
    
  window.pbReveal(document.querySelector('[data-pb-bms]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-final-cta"] && !Shopify.designMode) return;
  try {
    
  window.pbReveal(document.querySelectorAll('.pb-cta [data-pb-reveal]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-footer"] && !Shopify.designMode) return;
  try {
    
  /* Desktop (1024px+): the menus are always expanded via CSS, so
     aria-expanded needs to read true there — CSS can't set an HTML
     attribute, and the markup is shared with mobile's real accordion,
     so this is set here instead. The click handler is also short-
     circuited at this width, so a stray click (or Enter/Space on a
     focused button) can't flip it back to false. */
  var pbFootDesktop = window.matchMedia('(min-width: 1024px)');

  function setFootAria(isDesktop) {
    document.querySelectorAll('[data-pb-foot-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', isDesktop ? 'true' : 'false');
    });
  }

  setFootAria(pbFootDesktop.matches);
  pbFootDesktop.addEventListener('change', function (e) {
    setFootAria(e.matches);
  });

  document.addEventListener('click', function (e) {
    if (pbFootDesktop.matches) return;
    var btn = e.target.closest('[data-pb-foot-toggle]');
    if (!btn) return;
    var group = btn.closest('.pb-foot__group');
    if (!group) return;
    var open = group.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-pb-header]');
    if (!header) return;

    /* --pb-header-h: the fixed header's actual rendered height, for any
       section that needs to clear it (the header itself doesn't push
       the page — no padding-top added to body/main, the hero still
       sits under it at the very top exactly as before). */
    function setHeaderHeightVar() {
      document.documentElement.style.setProperty('--pb-header-h', header.offsetHeight + 'px');
    }

    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);

    /* Cart pill / link opens Dawn's cart drawer */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pb-cart]');
      if (!trigger) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(trigger);
      }
    });

    /* Shop link: glide to the product slider when it's on this page
       (pb-product-showcase has id="shop"); otherwise /#shop loads the
       homepage at the slider. */
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href$="#shop"]');
      var target = document.getElementById('shop');
      if (!link || !target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* ----- Mobile menu overlay ----- */
    var toggle = header.querySelector('[data-pb-menu-toggle]');
    var menu = document.querySelector('[data-pb-menu]');
    if (!toggle || !menu) return;

    function setMenu(open) {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
      header.classList.toggle('pb-header--menu-open', open);
      document.body.classList.toggle('overflow-hidden', open);
    }

    toggle.addEventListener('click', function () {
      setMenu(menu.hidden);
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && !menu.hidden) {
        setMenu(false);
        toggle.focus();
      }
    });

    /* Close the overlay when a link inside it is followed */
    menu.addEventListener('click', function (event) {
      if (event.target.closest('.pb-menu__link')) setMenu(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-journey"] && !Shopify.designMode) return;
  try {
    
  window.pbReveal(document.querySelector('[data-pb-journey]'));

  (function () {
    var section = document.querySelector('[data-pb-journey]');
    if (!section) return;
    var pin = section.querySelector('.pb-journey__pin');
    var bgs = section.querySelectorAll('.pb-journey__bg');
    var items = section.querySelectorAll('[data-pb-journey-item]');
    var ctas = section.querySelectorAll('.pb-journey__cta');
    var count = items.length;
    if (!count || !pin) return;

    var active = 0;

    function apply(list, i, hideInactive) {
      list.forEach(function (el, j) {
        el.classList.toggle('is-active', j === i);
        if (hideInactive) {
          el.setAttribute('tabindex', j === i ? '0' : '-1');
          el.setAttribute('aria-hidden', j === i ? 'false' : 'true');
        }
      });
    }

    function setActive(i) {
      if (i === active) return;
      active = i;
      apply(bgs, i, false);
      apply(items, i, false);
      apply(ctas, i, true);
    }

    /* Scroll work is class toggles only — the 200ms fades run on the
       compositor, so a throttled main thread cannot jank them. */
    var ticking = false;
    function update() {
      ticking = false;
      var travel = section.offsetHeight - pin.offsetHeight;
      if (travel <= 0) return;
      var top = section.getBoundingClientRect().top;
      var p = Math.min(Math.max(-top / travel, 0), 1);
      setActive(Math.min(count - 1, Math.round(p * (count - 1))));
    }
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-made-to-print"] && !Shopify.designMode) return;
  try {
    
  window.pbReveal(document.querySelector('[data-pb-mtp]'));

  (function () {
    /* Client-work marquee: continuous slow auto-scroll at constant speed,
       seamless loop. Nothing interrupts the motion — it only stops while
       off-screen or in a hidden tab (performance, not interaction). */
    var track = document.querySelector('.pb-mtp [data-pb-track]');
    if (!track) return;

    var copies = parseInt(track.dataset.copies, 10) || 1;
    var allSlides = track.querySelectorAll('.pb-mtp__slide');
    var perSet = allSlides.length / copies;
    if (perSet < 2 || copies < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var PXPS = 46;     /* continuous scroll speed, px per second — slow, calm */

    var step = 0, setWidth = 0, ready = false;
    var inView = false;
    var raf = null, lastTs = null, pos = 0;

    function measure() {
      if (allSlides.length < 2) return;
      step = allSlides[1].offsetLeft - allSlides[0].offsetLeft;
      setWidth = step * perSet;
      if (step > 0 && setWidth > 0) {
        ready = true;
        track.scrollLeft = setWidth; /* one set in — runway behind */
        pos = track.scrollLeft;
      }
    }

    function loop(ts) {
      if (lastTs === null) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;
      if (dt > 0.05) dt = 0.05; /* clamp after tab-switch stalls */
      pos += PXPS * dt;
      if (pos >= setWidth * 2) pos -= setWidth; /* seamless wrap */
      track.scrollLeft = pos;
      raf = requestAnimationFrame(loop);
    }

    function play() {
      if (reduce || raf || !ready || !inView || document.hidden) return;
      pos = track.scrollLeft; /* pick up from exactly where it sits */
      lastTs = null;
      raf = requestAnimationFrame(loop);
    }
    function pause() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      lastTs = null;
    }
    function sync() {
      if (!ready || !inView || document.hidden) pause();
      else play();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView && !ready) measure();
        });
        sync();
      }, { threshold: 0.2 });
      io.observe(track.closest('[data-pb-gallery]') || track);
    } else {
      inView = true;
      measure();
      sync();
    }

    window.addEventListener('resize', function () {
      ready = false;
      pause();
      measure();
      sync();
    });
    document.addEventListener('visibilitychange', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-onboarding"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pb-onboarding]');
    if (!root) return;

    var STORAGE_KEY = 'pb_onboarding';
    var panel = root.querySelector('.pb-ob__panel');
    var viewport = root.querySelector('[data-pb-ob-viewport]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pb-ob-step]'));
    var stepIds = steps.map(function (s) { return s.dataset.pbObStep; });
    var progress = root.querySelector('[data-pb-ob-progress]');
    var countEl = root.querySelector('[data-pb-ob-count]');
    var ruleEl = root.querySelector('[data-pb-ob-rule]');
    var announceEl = root.querySelector('[data-pb-ob-announce]');
    var nav = root.querySelector('[data-pb-ob-nav]');
    var backBtn = root.querySelector('[data-pb-ob-back]');
    var nextBtn = root.querySelector('[data-pb-ob-next]');
    var opener = null;

    /* Question steps counted by the hairline (welcome/confirm excluded) */
    var QUESTION_STEPS = stepIds.filter(function (id) { return id !== 'welcome' && id !== 'confirm'; });

    /* Every question advances via an explicit Continue (Finish on contact) */
    function nextLabelFor(id) {
      if (id === 'welcome' || id === 'confirm') return null;
      return id === 'contact' ? 'Finish' : 'Continue';
    }

    /* Choice steps keep Continue disabled until an answer exists */
    function stepComplete(id) {
      var a = state.answers;
      if (id === 'creating' || id === 'journey' || id === 'quantity') return !!a[id];
      if (id === 'printer') return !!a.hasPrinter;
      return true; /* garments, notes, contact: optional or validated on Finish */
    }

    function updateNextState() {
      if (nextBtn.hidden) return;
      var complete = stepComplete(state.step);
      nextBtn.disabled = !complete;
      nextBtn.setAttribute('aria-disabled', complete ? 'false' : 'true');
    }

    var state = {
      step: 'welcome',
      answers: {
        creating: null, journey: null, garments: [], mockup: null,
        location: null, quantity: null, hasPrinter: null,
        printerName: '', printerContact: '', notes: '',
        name: '', email: '', brand: '', website: ''
      }
    };

    /* ---------- Persistence ---------- */
    function save() {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    }
    function load() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var parsed = JSON.parse(raw);
        if (parsed && parsed.answers) {
          state.answers = Object.assign(state.answers, parsed.answers);
          if (stepIds.indexOf(parsed.step) !== -1) state.step = parsed.step;
        }
      } catch (e) {}
    }

    /* ---------- Phase 2 seam: mockup builder ---------- */
    function renderMockupStep(mountEl, currentState) {
      /* Phase 2 replaces this stub with the real mockup builder. */
      void mountEl; void currentState;
    }

    /* ---------- Phase 3 seam: submission ---------- */
    function submitOnboarding(collected) {
      /* Phase 3 replaces this with the real send. */
      console.log('[pb-onboarding] collected lead:', JSON.parse(JSON.stringify(collected)));
    }

    /* ---------- Rendering ---------- */
    function stepEl(id) {
      return root.querySelector('[data-pb-ob-step="' + id + '"]');
    }

    function reflectAnswers() {
      steps.forEach(function (section) {
        var id = section.dataset.pbObStep;
        var options = section.querySelectorAll('[data-pb-ob-option]');
        options.forEach(function (btn) {
          var val = btn.dataset.value;
          var pressed = false;
          if (id === 'garments') pressed = state.answers.garments.indexOf(val) !== -1;
          else if (id === 'printer') pressed = state.answers.hasPrinter === val;
          else pressed = state.answers[id] === val;
          btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
        });
      });
      root.querySelectorAll('[data-pb-ob-input]').forEach(function (input) {
        var key = input.dataset.pbObInput;
        if (key in state.answers && input.value !== state.answers[key]) input.value = state.answers[key];
      });
      var printerFields = root.querySelector('[data-pb-ob-printer-fields]');
      if (printerFields) printerFields.hidden = state.answers.hasPrinter !== 'Yes';
    }

    function show(id, direction) {
      state.step = id;
      panel.dataset.step = id;
      save();
      steps.forEach(function (s) { s.classList.remove('is-active', 'is-back'); });
      var active = stepEl(id);
      active.classList.add('is-active');
      if (direction === 'back') active.classList.add('is-back');

      var qIndex = QUESTION_STEPS.indexOf(id);
      var isQuestion = qIndex !== -1;
      progress.hidden = !isQuestion;
      if (isQuestion) {
        var num = qIndex + 1;
        var total = QUESTION_STEPS.length;
        countEl.textContent = 'Question ' + num + ' of ' + total;
        ruleEl.style.transform = 'scaleX(' + num / total + ')';
        announceEl.textContent = 'Question ' + num + ' of ' + total;
      }

      nav.hidden = id === 'welcome' || id === 'confirm';
      backBtn.style.visibility = id === 'welcome' || id === 'confirm' ? 'hidden' : 'visible';
      var nextLabel = nextLabelFor(id);
      nextBtn.hidden = !nextLabel;
      if (nextLabel) nextBtn.textContent = nextLabel;
      updateNextState();

      if (id === 'mockup') renderMockupStep(root.querySelector('[data-pb-ob-mockup-mount]'), state);

      viewport.scrollTop = 0;
      var heading = active.querySelector('.pb-ob__question');
      if (heading) heading.focus({ preventScroll: true });
    }

    function next() {
      var i = stepIds.indexOf(state.step);
      if (i < stepIds.length - 1) show(stepIds[i + 1], 'forward');
    }
    function back() {
      var i = stepIds.indexOf(state.step);
      if (i > 0) show(stepIds[i - 1], 'back');
    }

    /* ---------- Validation (contact step) ---------- */
    function validEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    }

    function validateContact() {
      var ok = true;
      var firstInvalid = null;
      [['name', state.answers.name.trim() !== ''], ['email', validEmail(state.answers.email.trim())]].forEach(function (pair) {
        var key = pair[0];
        var valid = pair[1];
        var input = root.querySelector('[data-pb-ob-input="' + key + '"]');
        var error = root.querySelector('[data-pb-ob-error="' + key + '"]');
        input.classList.toggle('is-invalid', !valid);
        if (error) error.hidden = valid;
        if (!valid) {
          ok = false;
          if (!firstInvalid) firstInvalid = input;
        }
      });
      if (firstInvalid) firstInvalid.focus();
      return ok;
    }

    /* ---------- Open / close ---------- */
    var lastFocusable = null;

    function open(trigger) {
      opener = trigger || null;
      load();
      reflectAnswers();
      root.hidden = false;
      document.body.classList.add('overflow-hidden');
      show(state.step, 'forward');
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      root.hidden = true;
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKeydown);
      save();
      if (opener && typeof opener.focus === 'function') opener.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      /* Focus trap */
      var focusables = panel.querySelectorAll('button:not([hidden]), a[href], input, textarea, [tabindex="-1"].is-active .pb-ob__question');
      var list = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null && !el.disabled;
      });
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      lastFocusable = document.activeElement;
      void lastFocusable;
    }

    /* ---------- Events ---------- */
    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-pb-onboarding-open]');
      if (openTrigger) {
        event.preventDefault();
        open(openTrigger);
      }
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-pb-ob-close]')) { close(); return; }
      if (event.target.closest('[data-pb-ob-begin]')) { next(); return; }
      if (event.target.closest('[data-pb-ob-back]')) { back(); return; }

      if (event.target.closest('[data-pb-ob-next]')) {
        if (nextBtn.disabled) return;
        if (state.step === 'contact') {
          if (!validateContact()) return;
          submitOnboarding(state.answers);
        }
        next();
        return;
      }

      var option = event.target.closest('[data-pb-ob-option]');
      if (option) {
        var section = option.closest('[data-pb-ob-step]');
        var id = section.dataset.pbObStep;
        var value = option.dataset.value;

        if (id === 'garments') {
          var idx = state.answers.garments.indexOf(value);
          if (idx === -1) state.answers.garments.push(value);
          else state.answers.garments.splice(idx, 1);
        } else if (id === 'printer') {
          state.answers.hasPrinter = value;
          if (value === 'Yes') {
            var firstField = root.querySelector('[data-pb-ob-printer-fields] input');
            if (firstField) window.setTimeout(function () { firstField.focus(); }, 50);
          }
        } else {
          state.answers[id] = value;
        }

        save();
        reflectAnswers();
        updateNextState();
      }
    });

    root.addEventListener('input', function (event) {
      var input = event.target.closest('[data-pb-ob-input]');
      if (!input) return;
      state.answers[input.dataset.pbObInput] = input.value;
      save();
    });

    /* Validate email on blur, not per keystroke */
    root.addEventListener('blur', function (event) {
      var input = event.target.closest && event.target.closest('[data-pb-ob-input="email"]');
      if (!input || input.value.trim() === '') return;
      var valid = validEmail(input.value.trim());
      input.classList.toggle('is-invalid', !valid);
      var error = root.querySelector('[data-pb-ob-error="email"]');
      if (error) error.hidden = valid;
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-print-partners"] && !Shopify.designMode) return;
  try {
    
  window.pbReveal(document.querySelectorAll('.pb-pp [data-pb-reveal]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-proof-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    document.querySelectorAll('[data-pb-proof-video]').forEach(function (box) {
      var wanted = isDesktop ? 'desktop' : 'mobile';
      var tpl = box.querySelector('template[data-pb-proof-tpl="' + wanted + '"]')
        || box.querySelector('template[data-pb-proof-tpl]');
      if (!tpl) return;

      box.insertBefore(tpl.content.cloneNode(true), box.firstChild);
      var video = box.querySelector('video');
      if (!video) return;

      var soundBtn = box.querySelector('[data-pb-proof-sound]');
      var playBtn = box.querySelector('[data-pb-proof-play]');

      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        box.classList.add('is-reduced-motion');
        if (playBtn) {
          playBtn.hidden = false;
          playBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            video.play();
            box.classList.remove('is-reduced-motion');
          });
        }
      } else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.5 });
        io.observe(video);
      }

      if (soundBtn) {
        /* Always read video.muted fresh rather than trust the state we
           just set — if the browser silently blocks the unmute (or
           anything else changes it), the icon still matches reality
           instead of drifting from a separately-tracked flag. */
        function syncSoundIcon() {
          var muted = video.muted;
          soundBtn.classList.toggle('is-muted', muted);
          soundBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
        }

        function toggleMute() {
          video.muted = !video.muted;
          syncSoundIcon();
        }

        syncSoundIcon();

        soundBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          toggleMute();
        });

        box.addEventListener('click', toggleMute);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
